/**
 * WRAPPER
 * @description function to convert miliseconds to a human readable format in Days / Hours / Minutes
 * @param {Number} ms time to convert
 */
const timeConverter = ms => {
  if (ms < 1000) return '<1 second'
  let seconds = ms / 1000
  const time = { day: 86400, hour: 3600, minute: 60, second: 1 }
  const result = []

  Object.entries(time).forEach(([key, value]) => {
    if (seconds >= value) {
      const val = Math.floor(seconds / value)
      result.push(`${val} ${key}${val > 1 ? 's' : ''}`)
      seconds %= value
    }
  })
  const last = result.pop()
  return `${result.join(', ')}${result.length > 0 ? ' and ' : ''}${last}`
}

module.exports = timeConverter
